import { render, staticRenderFns } from "./myAside.vue?vue&type=template&id=1e01d80b&scoped=true"
import script from "./myAside.vue?vue&type=script&lang=js"
export * from "./myAside.vue?vue&type=script&lang=js"
import style0 from "./myAside.vue?vue&type=style&index=0&id=1e01d80b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01d80b",
  null
  
)

export default component.exports